// config.js
module.exports = {
    BACKEND_API: process.env.REACT_APP_URL_API || 'http://localhost/',
}